import React from "react"
import Navbar from "../../Common/Navbar"
import Footer from "../../Common/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import AddTimeSheetComp from "./Component/AddTimeSheetComp"

const AddTimeSheet =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddTimeSheetComp />
        </div>
        <Footer />
        </>
    )
}

export default AddTimeSheet;